/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useContext, useEffect, useState, useCallback} from "react";
import {Button, Button2, Footer, Header, Surface, Tab, Text} from "components";
import {BaseWrapper} from "../../styles";
import {ButtonContainer, LoginContainer, TextStyled} from "./styles";
import {Link, useHistory} from "react-router-dom";
import Loader from "components/Loader";
import Colors from "constants/Colors";
import {GlobalAuthContext, GlobalLoaderContext} from "store/context";
import {Field, Form, Formik} from "formik";
import {
    InputField,
    Label,
    MultiSelectField,
    Section,
    SectionHeader,
    SectionLegend,
    SectionTitle,
    SelectField,
} from "components/Form";
import {Col, Row} from "components/Grid";
import * as Yup from "yup";
import {FitinsurAPI, MessageCenter} from "utils";
import Crypt from "utils/src/crypt";
import Access from 'constants/Access';
import TopHeader from "components/TopHeader/index";

export default function SecurityCode(props) {
    console.log(props.location.state)

    const crypt = new Crypt();
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);

    const [subtitleMessage, setSubtitleMessage] = useState(
        'Please enter the validation code sent to your e-mail:'
    );

    const history = useHistory();

    const goToHomePage = useCallback(() => {
        history.push('home');
    }, [history]);

    useEffect(() => localStorage.removeItem('session'), []);

    const handleSubmit = null;

    return (
        <BaseWrapper>
            <TopHeader />
            <LoginContainer>
                <Header title='Login' subtitle={subtitleMessage} />
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={{ securitycode: '' }}
                    validationSchema={Yup.object({
                        securitycode: Yup.string().required('* Required field')
                    })}
                >
                    {(props) => (
                        <Form>
                            <Surface>
                                <Section>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <Field
                                                name="securitycode"
                                                label="Security Code:"
                                                type="text"
                                                component={InputField}
                                                isRequired
                                                hideLabelAsterisk
                                                originalSize
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12} md={12} style={{ position: "static" }}>
                                            <ButtonContainer>
                                                    <Button
                                                        primary
                                                        type="submit"
                                                        id="btnLogin"
                                                        style={{}}
                                                    >
                                                        Next
                                                    </Button>
                                            </ButtonContainer>
                                        </Col>
                                    </Row>
                                </Section>
                            </Surface>
                        </Form>
                    )}
                </Formik>
                {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
            </LoginContainer>
            <Footer />
        </BaseWrapper>
    );
}